import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import Logo from "../../../../assets/Discount_App_logo.png";
import Image from "../../../../assets/business/images/login-page-img.png";

function BusinessWelcomePage() {
  const navigate = useNavigate();

  const handleLoginNavigate = () => {
    navigate("/business/login");
  };

  const handleNavigate = () => {
    navigate("/business/register");
  };
  return (
    <section className="welcome-screen">
      <div className="row m-0 align-items-center vh-100">
        <div className="col-md-6 p-0">
          <div className="welcome-screen-box">
            <div className="welcome-screen-box-in py-4">
              <div className="logo mb-4 text-center">
                <img src={Logo} alt="logo-img" />
              </div>
              <div className="heading-text-auth mb-5">
                <h3 className="h3-headline text-center mb-2">Let’s Get Started!</h3>
                <p className="subtitle-1 text-center">Log in with your email or phone number to access your dashboard.</p>
              </div>
              <div className="w-50 d-flex flex-column gap-3 w-100">
                <a
                  className="btn btn-oring w-100"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLoginNavigate();
                  }}>
                  Login
                </a>
                <a
                  className="btn btn-green w-100"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate();
                  }}>
                  Sign Up
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 p-0">
          <div className="hero-img">
            <img src={Image} className="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BusinessWelcomePage;
